import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import axios from 'axios'

export default {
  name: 'EditDeliveryRequestComment',
  extends: BaseModal,
  data: function () {
    return {
      comment: '',
    }
  },
  mounted() {
    let deliveryComment = !!this.data.deliveryRequest.deliveryComment
      ? this.data.deliveryRequest.deliveryComment
      : ''
    this.comment = this.isDeliverySecenarioByDelivery
      ? deliveryComment
      : this.data.deliveryRequest.comment
  },
  watch: {
    commentLenght: {
      handler: function () {
        this.commentLenght >= 70 ? (this.comment = this.comment.slice(0, 70)) : null
      },
    },
  },
  computed: {
    commentLenght() {
      return this.comment.length
    },
    isDeliverySecenarioByDelivery() {
      return this.data.deliveryRequest.deliveryScenario == 'by_deliverer'
    },
  },
  methods: {
    updateComment() {
      axios({
        method: 'put',
        url: `delivery_requests/${this.data.deliveryRequest.id}`,
        data: {
          comment: this.comment,
        },
      })
        .then(response => {
          mainApp.$emit(`updateDeliveryRequests`)
          this.close(false)
          console.log('response updateComment', response)
        })
        .catch(error => {
          this.close(false)
          console.error('error updateComment', error)
        })
    },
  },
}
